import { render, staticRenderFns } from "./FiltrosDisposicion.vue?vue&type=template&id=202b9aaf&"
import script from "./FiltrosDisposicion.vue?vue&type=script&lang=js&"
export * from "./FiltrosDisposicion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports